const common = {
  Test: 'Test',
  Save: 'Save',
};

export default common;
